import * as React from 'react';

export function Professionalize() {
  return (
    <section className="gastro-pro">
      <style>{`
        .gastro-pro {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .gastro-pro-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .gastro-pro h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .gastro-pro .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 40px;
        }
        .gastro-pro-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }
        .gastro-pro-card {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          background: #fff;
          border-radius: 12px;
          padding: 18px 20px;
          border: 1px solid #eee;
        }
        .gastro-pro-card .card-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #f0fdf0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .gastro-pro-card .card-icon i {
          font-size: 18px;
          color: #1EAA25;
        }
        .gastro-pro-card-text h3 {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px;
        }
        .gastro-pro-card-text p {
          font-size: 14px;
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
        .gastro-pro .closing {
          text-align: center;
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin: 36px 0 0;
        }
        @media (max-width: 768px) {
          .gastro-pro-cards {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .gastro-pro h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="gastro-pro-inner">
        <h2>Profesionalizá tu abastecimiento</h2>
        <p className="subtitle">Ordenar el abastecimiento es parte del crecimiento.</p>

        <div className="gastro-pro-cards">
          <div className="gastro-pro-card">
            <div className="card-icon"><i className="fa fa-file-invoice" /></div>
            <div className="gastro-pro-card-text">
              <h3>Facturación clara</h3>
              <p>Comprás en blanco. Registrás tus compras. Ordenás tus números.</p>
            </div>
          </div>
          <div className="gastro-pro-card">
            <div className="card-icon"><i className="fa fa-credit-card" /></div>
            <div className="gastro-pro-card-text">
              <h3>Cuenta corriente predecible</h3>
              <p>Crédito definido y transparente. Sin favores. Sin improvisación.</p>
            </div>
          </div>
          <div className="gastro-pro-card">
            <div className="card-icon"><i className="fa fa-chart-simple" /></div>
            <div className="gastro-pro-card-text">
              <h3>Historial y trazabilidad</h3>
              <p>Sabés cuánto compraste, cuándo y a qué precio.</p>
            </div>
          </div>
        </div>

        <p className="closing">Un restaurante profesional necesita proveedores profesionales.</p>
      </div>
    </section>
  );
}
